<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" v-show="showSearch">
      <el-form-item prop="iccid">
        <el-input
          v-model="queryParams.iccid"
          placeholder="请输入ICCID"
          clearable
          style="width: 240px"
          @keyup.enter.native="search"
        />
      </el-form-item>
      <el-form-item  prop="missionId">
        <el-input
          v-model="queryParams.missionId"
          placeholder="请输入任务ID"
          clearable
          style="width: 240px"
          @keyup.enter.native="search"
        />
      </el-form-item>
      <el-form-item  prop="status">
        <el-select v-model="queryParams.status" 
        placeholder="请选择状态" 
        style="width: 240px" 
        clearable
        @change="search"
        >
          <el-option
            v-for="item in batchStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="tableData" >
      <el-table-column type="index" label="序号" align="center"></el-table-column>
      <el-table-column  prop="companyName" label="操作账号" align="center" width="220" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column  label="ICCID" prop="iccid" align="center" width="220" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="jumpButton(scope.row.iccid)">{{ scope.row.iccid }}</el-link>
          </template>
      </el-table-column>
      <el-table-column prop="activeTime" label="激活时间" align="center"  width="220" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="expireTime" label="过期时间" align="center"  width="220" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="monthFlow" label="当月流量" align="center"  width="220" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="kycStatus" label="实名状态" align="center"  width="220" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="missionId" label="任务ID" align="center"  width="220" :show-overflow-tooltip="true" ></el-table-column>
      
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.status =='1'"  type="success">成功</el-tag>
          <el-tag v-else type="danger">失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="清除时间" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="失败原因" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="160" >
        <template slot-scope="scope" >
            <el-button
              size="mini"
              type="primary"
              plain icon="el-icon-view"
              @click="infoRow(scope.row.iccid)"
            >详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
    </div>
    <!--卡清除记录-->
    <el-dialog :title="title" :visible.sync="open" width="900px"   append-to-body :close-on-click-modal="false">
      <el-tabs v-model="activeName" class="card-tab">
      <el-tab-pane label="资费列表" name="cardProduct">
        <el-table :data="tableCardProduct" border style="width: 95%">
          <el-table-column prop="orderNum" label="订单号" align="center" width="220" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="productName" label="套餐名" align="center" width="220" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="useFlow" label="已用流量" align="center"></el-table-column>
          <el-table-column prop="monthFlow" label="总流量" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="status" label="套餐状态" align="center"  width="180" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="originalStatus" label="原套餐状态" align="center" width="180" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="startTime" label="开始时间" align="center" width="220" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="endTime" label="结束时间" align="center" width="220" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
        <el-pagination
          v-show="cardProductCount>0"
          @size-change="handleCardPageSizeChange"
          @current-change="handleCardProdcutCurrentChange"
          :current-page="cardProductPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="cardProductPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="cardProductCount"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="订单列表" name="orderList">
        <el-table :data="tableOrderInfo" border style="width: 95%">
          <el-table-column prop="orderNum" label="订单号"  align="center" width="220" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="productName" label="资费名" align="center" width="220" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="productFlow" label="资费流量" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="accountMoney" label="价格" align="center"></el-table-column>
          <el-table-column prop="orderStatus" label="状态" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ transferOrderStatus(scope.row.orderStatus) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="originalStatus" label="原状态" align="center" width="120"  :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ transferOrderStatus(scope.row.originalStatus) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="支付方式" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ transferPayType(scope.row.payType) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="paymentTime" label="支付时间" align="center" width="220" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
         <el-pagination
          v-show="totalOrder>0"
          @size-change="handleOrderSizeChange"
          @current-change="handleOrderCurrentChange"
          :current-page="orderPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="orderPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalOrder"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import {cardRemovalRecord} from "@/api/api"; //订单
import { cardProductPage,orderList } from "@/api/api.js"; //资费列表
export default {
  name:'cardRemoval',
  data() {
    return {
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 搜索
      queryParams:{
        userId:undefined,
        iccid:undefined,
        missionId:undefined,
        status:undefined,
      },
      batchStatus:[
          {
            value:1,
            label:'成功'
          },
          {
            value:0,
            label:'失败'
          }
      ],
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      title:'卡清除记录',
      open:false,
      tableCardProduct: [],
      tableOrderInfo: [],
      activeName:'cardProduct',
      totalOrder:0,
      orderPage:1,
      orderPageSize:10,
      cardProductCount:0,
      cardProductPage:1,
      cardProductPageSize:10,
      iccid:undefined
    };
  },
  computed: {
  },
  methods: {
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    handleCardPageSizeChange(pageSize) {
      this.cardProductPageSize = pageSize;
      this.initProductInfo();
    },
    handleCardProdcutCurrentChange(page) {
      this.cardProductPage = page;
      this.initProductInfo();
    },
    handleOrderSizeChange(pageSize) {
      this.orderPageSize = pageSize;
      this.initOrderInfo();
    },
    handleOrderCurrentChange(page) {
      this.orderPage = page;
      this.initOrderInfo();
    },
    transferOrderStatus(status) {
      let obj = {
        1: "未支付",
        2: "已支付",
        3: "已到账",
        4: "已退款",
        6: "已清除"
      };
      return obj[status];
    },
    // 支付方式
    transferPayType(status){
      let obj = {
        1: "微信H5支付",
        2: "微信支付",
        3: "余额支付",
        4: "系统支付",
        5: "支付宝H5支付",
        6: "贝宝支付",
        7: "佣金支付",
        8: "小程序支付",
      };
      return obj[status];
    },
    initData() {
      this.loading = true;
      let params = {
        model:{
          ...this.queryParams
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      cardRemovalRecord(params).then(res => {
        this.loading = false;
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        }
      });
    },
    // 页面跳转
    handleClick(routerPath){
      this.$router.push(routerPath);
    },
    /** 搜索按钮操作 */
    search() {
      this.page = 1,
      this.initData();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    // 详情
    infoRow(iccid) {
      this.iccid = iccid;
      this.initProductInfo();
      this.initOrderInfo();
      this.open = true;
    },
    // 获取资费列表
    initProductInfo() {
      let params = {
        model:{
          iccid: this.iccid,
          status:['7']
        },
        page: this.cardProductPage,
        pageSize: this.cardProductPageSize,
      };
      cardProductPage(params).then(res => {
        if (res.data.code == 200) {
          this.tableCardProduct = res.data.data.records;
          this.cardProductCount = res.data.data.total;
        }
      });
    },
    jumpButton(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    },
    initOrderInfo() {
      let params = {
        model:{
          iccid: this.iccid,
          orderStatus:['6']
        },
        page: this.orderPage,
        pageSize: this.orderPageSize
      };
      orderList(params).then(res => {
        if (res.data.code == 200) {
          this.tableOrderInfo = res.data.data.records;
          for(let i = 0;i < this.tableOrderInfo.length;i++){
            this.tableOrderInfo[i].productFlow = Math.round(this.tableOrderInfo[i].productFlow*100)/100
            if(this.tableOrderInfo[i].productFlow < 0 ){
              this.tableOrderInfo[i].productFlow = '畅享'
            }
          }
          this.totalOrder = res.data.data.total;
        }
      });
    },
  },
  created() {
    this.initData()
  },
  mounted() {}
};
</script>